import { useAtomValue } from 'jotai';

import { jobPositionApiDataAtom } from '../components/job-position/job-position.atoms';

export const useJobPositionId = () => {
  const jobPositionApiData = useAtomValue(jobPositionApiDataAtom);
  return jobPositionApiData?.id ?? '';
};
